<div class="w-full h-full px-5 py-3 flex flex-col gap-5">
  <div class="flex justify-between items-center">
    <div class="text-2xl font-semibold">
      {{ 'devices.detailTabs.configuration.titleChangeInitialConfig' | translate }}
    </div>
    <button
      mat-icon-button
      class="float-right -mt-3 -mr-3"
      [disabled]="isSending"
      (click)="dialogRef.close()"
    >
      <mat-icon class="text-primary mb-1">close</mat-icon>
    </button>
  </div>

  <div
    class="flex items-start gap-2 rounded-lg border border-amber-300 bg-amber-50 p-3 text-amber-800 text-sm"
  >
    <mat-icon class="shrink-0 text-amber-500 !text-[20px] !w-5 !h-5 mt-0.5">warning</mat-icon>
    <span>{{ 'devices.detailTabs.configuration.initialConfigResetWarning' | translate }}</span>
  </div>
  <div class="border border-[#ECECF2] rounded-lg p-4 overflow-auto">
    @if (isLoading) {
      <div class="flex justify-center items-center py-4">
        <mat-spinner diameter="20" color="primary"></mat-spinner>
      </div>
    } @else if (initialConfigurations.length === 0) {
      <p class="text-sm text-gray-500 py-2">
        {{ 'devices.detailTabs.configuration.noInitialConfigsAvailable' | translate }}
      </p>
    } @else {
      <mat-form-field class="w-full">
        <mat-label>{{
          'devices.detailTabs.configuration.initialConfiguration' | translate
        }}</mat-label>
        <mat-select [(ngModel)]="selectedFileId">
          <mat-select-trigger>
            @for (item of initialConfigurations; track item) {
              @if (item.fileId === selectedFileId) {
                {{ item.description }}
              }
            }
          </mat-select-trigger>
          @for (item of initialConfigurations; track item.fileId) {
            <mat-option [value]="item.fileId">
              <div class="flex items-center gap-2">
                <span class="text-[13px] font-bold">{{ item.description }}</span>
                <span class="text-sm font-medium">{{ item.fileName }}</span>
              </div>
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
  </div>
  @if (sendError) {
    <span class="text-red-500 text-sm max-w-sm">{{ sendError }}</span>
  }

  <mat-dialog-actions>
    @if (succeeded) {
      <span class="flex items-center gap-1 text-green-600">
        <mat-icon>check_circle</mat-icon>
        {{ 'devices.detailTabs.configuration.sendSuccess' | translate }}
      </span>
      <button mat-stroked-button type="button" (click)="dialogRef.close()">
        {{ 'devices.detailTabs.configuration.closingIn' | translate: { seconds: countdown } }}
      </button>
    } @else {
      <button
        mat-flat-button
        type="button"
        color="secondary"
        [disabled]="selectedFileId == null || isSending"
        (click)="confirm()"
      >
        @if (isSending) {
          <mat-spinner diameter="16"></mat-spinner>
        } @else {
          {{ 'devices.detailTabs.configuration.btnChangeInitialConfig' | translate }}
        }
      </button>
      <button mat-stroked-button type="button" [disabled]="isSending" (click)="dialogRef.close()">
        {{ 'general.btnCancel' | translate }}
      </button>
    }
  </mat-dialog-actions>
</div>
